(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.DocCountryUpdate = factory(root.SmartCsV2Sdk.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The DocCountryUpdate model module.
   * @module model/DocCountryUpdate
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>DocCountryUpdate</code>.
   * @alias module:model/DocCountryUpdate
   * @class
   */
  var exports = function() {



  };

  /**
   * Constructs a <code>DocCountryUpdate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DocCountryUpdate} obj Optional instance to populate.
   * @return {module:model/DocCountryUpdate} The populated <code>DocCountryUpdate</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('data')) {
        obj['data'] = ApiClient.convertToType(data['data'], 'String');
      }
      if (data.hasOwnProperty('op')) {
        obj['op'] = ApiClient.convertToType(data['op'], 'String');
      }
    }
    return obj;
  }


  /**
   * @member {module:model/DocCountryUpdate.DataEnum} data
   */
  exports.prototype['data'] = undefined;

  /**
   * @member {module:model/DocCountryUpdate.OpEnum} op
   */
  exports.prototype['op'] = undefined;


  /**
   * Allowed values for the <code>data</code> property.
   * @enum {String}
   * @readonly
   */
  exports.DataEnum = { 
    /**
     * value: ALGERIA
     * @const
     */
    ALGERIA: "ALGERIA",
    
    /**
     * value: ARGENTINA
     * @const
     */
    ARGENTINA: "ARGENTINA",
    
    /**
     * value: AUSTRALIA
     * @const
     */
    AUSTRALIA: "AUSTRALIA",
    
    /**
     * value: AUSTRIA
     * @const
     */
    AUSTRIA: "AUSTRIA",
    
    /**
     * value: BANGLADESH
     * @const
     */
    BANGLADESH: "BANGLADESH",
    
    /**
     * value: BELGIUM
     * @const
     */
    BELGIUM: "BELGIUM",
    
    /**
     * value: BRAZIL
     * @const
     */
    BRAZIL: "BRAZIL",
    
    /**
     * value: CANADA
     * @const
     */
    CANADA: "CANADA",
    
    /**
     * value: CHILE
     * @const
     */
    CHILE: "CHILE",
    
    /**
     * value: CHINA
     * @const
     */
    CHINA: "CHINA",
    
    /**
     * value: COLOMBIA
     * @const
     */
    COLOMBIA: "COLOMBIA",
    
    /**
     * value: CYPRUS
     * @const
     */
    CYPRUS: "CYPRUS",
    
    /**
     * value: CZECH_REPUBLIC
     * @const
     */
    CZECH_REPUBLIC: "CZECH_REPUBLIC",
    
    /**
     * value: DOMINICAN_REPUBLIC
     * @const
     */
    DOMINICAN_REPUBLIC: "DOMINICAN_REPUBLIC",
    
    /**
     * value: ECUADOR
     * @const
     */
    ECUADOR: "ECUADOR",
    
    /**
     * value: EGYPT
     * @const
     */
    EGYPT: "EGYPT",
    
    /**
     * value: ENGLAND
     * @const
     */
    ENGLAND: "ENGLAND",
    
    /**
     * value: ETHIOPIA
     * @const
     */
    ETHIOPIA: "ETHIOPIA",
    
    /**
     * value: FRANCE
     * @const
     */
    FRANCE: "FRANCE",
    
    /**
     * value: GERMANY
     * @const
     */
    GERMANY: "GERMANY",
    
    /**
     * value: GREECE
     * @const
     */
    GREECE: "GREECE",
    
    /**
     * value: HONG_KONG
     * @const
     */
    HONG_KONG: "HONG_KONG",
    
    /**
     * value: HUNGARY
     * @const
     */
    HUNGARY: "HUNGARY",
    
    /**
     * value: INDIA
     * @const
     */
    INDIA: "INDIA",
    
    /**
     * value: INDONESIA
     * @const
     */
    INDONESIA: "INDONESIA",
    
    /**
     * value: IRAN
     * @const
     */
    IRAN: "IRAN",
    
    /**
     * value: IRAQ
     * @const
     */
    IRAQ: "IRAQ",
    
    /**
     * value: IRELAND
     * @const
     */
    IRELAND: "IRELAND",
    
    /**
     * value: ISRAEL
     * @const
     */
    ISRAEL: "ISRAEL",
    
    /**
     * value: ITALY
     * @const
     */
    ITALY: "ITALY",
    
    /**
     * value: JAPAN
     * @const
     */
    JAPAN: "JAPAN",
    
    /**
     * value: KAZAKHSTAN
     * @const
     */
    KAZAKHSTAN: "KAZAKHSTAN",
    
    /**
     * value: KOREA_REPUBLIC_OF
     * @const
     */
    KOREA_REPUBLIC_OF: "KOREA_REPUBLIC_OF",
    
    /**
     * value: LITHUANIA
     * @const
     */
    LITHUANIA: "LITHUANIA",
    
    /**
     * value: MALAYSIA
     * @const
     */
    MALAYSIA: "MALAYSIA",
    
    /**
     * value: MEXICO
     * @const
     */
    MEXICO: "MEXICO",
    
    /**
     * value: MOROCCO
     * @const
     */
    MOROCCO: "MOROCCO",
    
    /**
     * value: MYANMAR
     * @const
     */
    MYANMAR: "MYANMAR",
    
    /**
     * value: NETHERLANDS
     * @const
     */
    NETHERLANDS: "NETHERLANDS",
    
    /**
     * value: NIGERIA
     * @const
     */
    NIGERIA: "NIGERIA",
    
    /**
     * value: NORTHERN_IRELAND
     * @const
     */
    NORTHERN_IRELAND: "NORTHERN_IRELAND",
    
    /**
     * value: PAKISTAN
     * @const
     */
    PAKISTAN: "PAKISTAN",
    
    /**
     * value: PANAMA
     * @const
     */
    PANAMA: "PANAMA",
    
    /**
     * value: PERU
     * @const
     */
    PERU: "PERU",
    
    /**
     * value: PHILIPPINES
     * @const
     */
    PHILIPPINES: "PHILIPPINES",
    
    /**
     * value: POLAND
     * @const
     */
    POLAND: "POLAND",
    
    /**
     * value: PORTUGAL
     * @const
     */
    PORTUGAL: "PORTUGAL",
    
    /**
     * value: PUERTO_RICO
     * @const
     */
    PUERTO_RICO: "PUERTO_RICO",
    
    /**
     * value: ROMANIA
     * @const
     */
    ROMANIA: "ROMANIA",
    
    /**
     * value: RUSSIA
     * @const
     */
    RUSSIA: "RUSSIA",
    
    /**
     * value: SAUDI_ARABIA
     * @const
     */
    SAUDI_ARABIA: "SAUDI_ARABIA",
    
    /**
     * value: SCOTLAND
     * @const
     */
    SCOTLAND: "SCOTLAND",
    
    /**
     * value: SENEGAL
     * @const
     */
    SENEGAL: "SENEGAL",
    
    /**
     * value: SINGAPORE
     * @const
     */
    SINGAPORE: "SINGAPORE",
    
    /**
     * value: SLOVAKIA
     * @const
     */
    SLOVAKIA: "SLOVAKIA",
    
    /**
     * value: SLOVENIA
     * @const
     */
    SLOVENIA: "SLOVENIA",
    
    /**
     * value: SOUTH_AFRICA
     * @const
     */
    SOUTH_AFRICA: "SOUTH_AFRICA",
    
    /**
     * value: SPAIN
     * @const
     */
    SPAIN: "SPAIN",
    
    /**
     * value: SUDAN
     * @const
     */
    SUDAN: "SUDAN",
    
    /**
     * value: SWEDEN
     * @const
     */
    SWEDEN: "SWEDEN",
    
    /**
     * value: SWITZERLAND
     * @const
     */
    SWITZERLAND: "SWITZERLAND",
    
    /**
     * value: TAIWAN
     * @const
     */
    TAIWAN: "TAIWAN",
    
    /**
     * value: THAILAND
     * @const
     */
    THAILAND: "THAILAND",
    
    /**
     * value: TUNISIA
     * @const
     */
    TUNISIA: "TUNISIA",
    
    /**
     * value: TURKEY
     * @const
     */
    TURKEY: "TURKEY",
    
    /**
     * value: UKRAINE
     * @const
     */
    UKRAINE: "UKRAINE",
    
    /**
     * value: UNITED_ARAB_EMIRATES
     * @const
     */
    UNITED_ARAB_EMIRATES: "UNITED_ARAB_EMIRATES",
    
    /**
     * value: UNITED_STATES
     * @const
     */
    UNITED_STATES: "UNITED_STATES",
    
    /**
     * value: UZBEKISTAN
     * @const
     */
    UZBEKISTAN: "UZBEKISTAN",
    
    /**
     * value: VENEZUELA
     * @const
     */
    VENEZUELA: "VENEZUELA",
    
    /**
     * value: VIETNAM
     * @const
     */
    VIETNAM: "VIETNAM",
    
    /**
     * value: WALES
     * @const
     */
    WALES: "WALES"
  };  /**
   * Allowed values for the <code>op</code> property.
   * @enum {String}
   * @readonly
   */
  exports.OpEnum = { 
    /**
     * value: SET
     * @const
     */
    SET: "SET",
    
    /**
     * value: UNSET
     * @const
     */
    UNSET: "UNSET",
    
    /**
     * value: APPEND
     * @const
     */
    APPEND: "APPEND"
  };

  return exports;
}));
